import { Controller } from "@hotwired/stimulus"

let modal;

export default class extends Controller {
  static targets = [ "form", "fileInput", "s3KeyInput" ]

  connect() {
    // console.log("Hello, Direct Uploads Controller here!", this.element)
    // console.log(this.formTarget)
    // console.log(this.fileInputTarget)
    // console.log(this.s3KeyInputTarget)

    modal = new bootstrap.Modal(document.getElementById('waitForTheMagicModal'));
  }

  async handleDirectUpload(event) {
    const file = this.fileInputTarget.files[0]
    if (!file) return

    event.preventDefault();

    modal.show();

    // Request a pre-signed URL from the backend
    const response = await fetch("/direct_uploads", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({
        filename: file.name,
        content_type: file.type
      })
    })

    const { url, key } = await response.json()

    // debugger;

    // PUT the file directly to S3
    const upload = await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": file.type
      },
      body: file
    })

    // debugger;

    if (upload.ok) {
      console.log("Upload successful:", key)
      this.s3KeyInputTarget.value = key

      // optionally show uploaded file name, progress, etc.

      // submit the form
      this.formTarget.submit();
    } else {
      alert("Upload failed.")
    }
  }

}
